import { Component, ElementRef, inject, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BranchMasterReadByUserIdRequestDTO } from 'src/app/Common/BranchMasterService/branchmaster.interface';
import { BranchMasterService } from 'src/app/Common/BranchMasterService/branchmaster.service';
import { GetDictionaryDTO, PaginatedDTO } from 'src/app/Common/common.interface';
import { OpenAIService } from 'src/app/Common/OpenAIService/OpenAI.service';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { DBConfigDTO, DBConfigReadAllRequestDTO } from 'src/app/notification/dbconfig/dbconfig.interface';
import { DBConfigService } from 'src/app/notification/dbconfig/dbconfig.service';
import { EmailConfigDTO, EmailConfigReadAllRequestDTO } from 'src/app/notification/email-config/email-config.interface';
import { EmailConfigService } from 'src/app/notification/email-config/email-config.service';
import { NotificationMaster_CreateRequestDTO } from 'src/app/notification/history/history.interface';
import { HistoryService } from 'src/app/notification/history/history.service';
import { ConfirmmodalserviceService } from 'src/app/Shared/confirm-delete-modal/confirmmodalservice.service';
import { environment } from 'src/environments/environment';
import { compEmailTempVarCreateRequestDTO, compEmailTempVarDeleteRequestDTO, compEmailTempVarReadByTemplateIdRequestDTO, compEmailTempVarUpdateRequestDTO, compEmailVarResponseItem } from './company-email-templates-variables.interface';
import { EmailVariableService } from './company-email-templates-variables.service';
import { CompEmailItem, CompEmailTempCreateRequestDTO, CompEmailTempDeleteRequestDTO, CompEmailTempReadAllPaginatedDTO, CompEmailTempUpdateRequestDTO } from './company-email-templates.interface';
import { EmailService } from './company-email-templates.service';
import { SoftwareMasterService } from '../../software-master/software-master.service';
import { ApiConfigurationDTO } from 'src/app/Common/ApiConfigurationService/api-configuration.interface';

@Component({
  selector: 'app-company-email-templates',
  templateUrl: './company-email-templates.component.html',
  styleUrls: ['./company-email-templates.component.css']
})
export class CompanyEmailTemplatesComponent implements OnChanges {

  @Input() companyId: number = 0;
  // Read-only override of the viewed tenant's own gateway URLs (Customer
  // Details page's Email Template tab). Also used at notification/email-template
  // with [companyId]="this.User.companyId" - new @Input defaults null, safe
  // there. getDBConfigList() and getModuleList() below stay on the default
  // URL - they're scoped to the admin's own tenant / have no tenant filter.
  @Input() apiConfigOverride: ApiConfigurationDTO | null = null;
  @Input() defaultBranchId: number = 0;
  // Flags
  isLoading: boolean = false;
  isAddDisabled = false;
  isSelectionChanged: boolean = false;
  isDataLoaded: boolean = false;
  errorMessage: string = '';
  templateId: number = 1
  sendEmailLoader: boolean = false;
  isSubmitting: boolean = false;


  // Service 
  public modalService = inject(NgbModal)
  historyService = inject(HistoryService);

  emailService = inject(EmailService)
  emailConfigService = inject(EmailConfigService)
  emailVaribleService = inject(EmailVariableService)
  User = inject(UserLoginService).User();
  public confirmModal = inject(ConfirmmodalserviceService)
  branchMasterService = inject(BranchMasterService);
  DBConfigService = inject(DBConfigService)
  SMService = inject(SoftwareMasterService)
  openAIService = inject(OpenAIService)


  // Items 
  EmailList: CompEmailItem[] = [];
  branchList: { key: string; value: string }[] = [];
  branchIdControl = new FormControl(0);
  emailConfigList: EmailConfigDTO[] = [];
  emailVariableList: compEmailVarResponseItem[] = [];
  emailDBList: DBConfigDTO[] = []
  moduleList: GetDictionaryDTO[] = []


  emailStepperModal!: NgbModalRef;
  @ViewChild('EmailStepperContent', { static: false }) stepperModalContent!: ElementRef;

  viewModal!: NgbModalRef;
  @ViewChild('ViewEmailContent', { static: false }) viewEmailContent!: ElementRef;
  selectedTemplate: CompEmailItem | null = null;


  ReadAllDTO: PaginatedDTO = {
    rowNum: 0,
    totalCount: 0,
    whereClause: '',
    orderByClause: '',
    pageSize: 10,
    pageNo: 1,
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
    softwareId: Number(environment.SoftwareId)

  }

  EmailForm = new FormGroup({
    templateId: new FormControl(0),

    tName: new FormControl('', Validators.required),
    tDesc: new FormControl(''),
    moduleName: new FormControl('', Validators.required),

    subModuleName: new FormControl(''),

    dataSourceType: new FormControl(''),
    dataSourceDefination: new FormControl(''),
    postDataSourceType: new FormControl(''),
    postDataSourceDefination: new FormControl(''),

    emailTO: new FormControl(''),
    ccTo: new FormControl(''),
    bccTo: new FormControl(''),
    aSubject: new FormControl(''),
    aBody: new FormControl(''),
    emailConfigId: new FormControl(0),
    DBConfig: new FormControl(0),

    otherDetail1: new FormControl(''),
    otherDetail2: new FormControl(''),
    otherDetail3: new FormControl(''),
    otherDetail4: new FormControl(''),
    otherDetail5: new FormControl(''),
    otherDetail6: new FormControl(''),

    whereClause: new FormControl('')
  });

  EmailVariableForm = new FormGroup({
    variableId: new FormControl(0),
    templateId: new FormControl(0),
    varInstance: new FormControl('', Validators.required),
    varValue: new FormControl('', Validators.required),
    varType: new FormControl('', Validators.required),
    otherDetail1: new FormControl(''),
    otherDetail2: new FormControl(''),
    otherDetail3: new FormControl(''),
    otherDetail4: new FormControl(''),
    otherDetail5: new FormControl(''),
    otherDetail6: new FormControl(''),

  })

  varTypeOptions = [
    { value: 'String', label: 'String' },
    { value: 'Int', label: 'Int' },
  ];
  loadingAITemplate: boolean = false;
  isUniversalEditing: boolean = false;


  constructor() { }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['companyId'] && changes['companyId'].currentValue !== changes['companyId'].previousValue) {
      this.getEmailListPaginated();
      this.getBranchList();
      this.getModuleList();
      this.getDBConfigList();
      this.getEmailConfigList();
    }
  }

  // Baisc API Calls 
  getEmailListPaginated() {
    this.isLoading = true;
    this.ReadAllDTO.tenantId = this.companyId;
    // Otherwise stays at its initializer's this.User.loggedInBranchId (the
    // ADMIN's own branch) until branchIdControl resolves later - wrong for
    // this call's very first firing from ngOnChanges.
    this.ReadAllDTO.tenantBranchId = this.branchIdControl.value || this.defaultBranchId;
    const payload: CompEmailTempReadAllPaginatedDTO = {
      tenantId: this.ReadAllDTO.tenantId,
      tenantBranchId: this.ReadAllDTO.tenantBranchId,
      pageSize: this.ReadAllDTO.pageSize,
      pageNo: this.ReadAllDTO.pageNo,
      whereClause: this.ReadAllDTO.whereClause,
      orderByClause: this.ReadAllDTO.orderByClause,
    };
    // this.emailService.CompanyEmailTemplate_ReadByTenantId(data).subscribe({
    this.emailService.CompanyEmailTemplate_ReadAllPaginated(payload, this.apiConfigOverride?.am, payload.tenantId, payload.tenantBranchId ?? this.defaultBranchId).subscribe({
      next: (res) => {
        this.EmailList = res.items;
        this.isLoading = false;
        this.isSelectionChanged = false;
        this.isDataLoaded = true;
        this.errorMessage = '';
        this.isAddDisabled = false; //
        // Only close modal if it exists (modal is only initialized when explicitly opened)
        this.emailStepperModal?.close()
      },
      error: (err) => {

        this.isLoading = false;
        this.EmailList = [];
        this.isDataLoaded = false;
        this.errorMessage = 'Failed to load Email List for the selected company/branch.';
        this.isAddDisabled = true; // keep disabled if load fails
      }
    });
  }

  createEmailTemplate(data: CompEmailTempCreateRequestDTO) {
    this.emailService.CompanyEmailTemplate_Create(data).subscribe({
      next: () => {
        this.getEmailListPaginated();
        this.emailStepperModal.close()
        this.isSubmitting = false;
      },
      error: (err) => {
        console.error('Create error:', err);
        this.isSubmitting = false;
      }
    });
  }

  updateEmailTemplate(data: CompEmailTempUpdateRequestDTO) {
    this.emailService.CompanyEmailTemplate_Update(data).subscribe({
      next: () => {
        this.getEmailListPaginated();
        this.emailStepperModal.close()
        this.isSubmitting = false;
      },
      error: (err) => {
        console.error('Update error:', err);
        this.isSubmitting = false;
      }
    })
  }

  deleteEmailTemplate(data: CompEmailTempDeleteRequestDTO) {
    this.emailService.CompanyEmailTemplate_Delete(data).subscribe(res => {
      this.getEmailListPaginated()
    })
  }

  // Event Management
  openModal() {
    this.EmailForm.reset()
    this.currentStep = 1;
    this.EmailForm.controls.moduleName.setValue(this.moduleList[1].value);
    this.emailStepperModal = this.modalService.open(this.stepperModalContent, { size: "xl" });
  }

  submitAllForms() {
    this.EmailForm.markAllAsTouched();

    if (this.EmailForm.invalid) {
      console.warn('Form is invalid. Please correct the errors before submitting.');
      return;
    }
    else {
      this.isSubmitting = true;

      const formData = { ...this.EmailForm.value }
      const tenantBranchId = this.branchIdControl.value ?? this.User.loggedInBranchId;
      if (this.EmailForm.value.templateId && this.EmailForm.value.templateId > 0) {
        const data: CompEmailTempUpdateRequestDTO = {
          templateId: formData.templateId ?? 0,
          tenantId: this.companyId,
          tenantBranchId: this.User.loggedInBranchId,

          tName: formData.tName ?? '',
          tDesc: formData.tDesc ?? '',
          moduleName: formData.moduleName ?? '',
          subModuleName: formData.subModuleName ?? '',

          dataSourceType: formData.dataSourceType ?? '',
          dataSourceDefination: formData.dataSourceDefination ?? '',
          postDataSourceType: formData.postDataSourceType ?? '',
          postDataSourceDefination: formData.postDataSourceDefination ?? '',

          emailTO: formData.emailTO ?? '',
          ccTo: formData.ccTo ?? '',
          bccTo: formData.bccTo ?? '',
          aSubject: formData.aSubject ?? '',
          aBody: formData.aBody ?? '',
          emailConfigId: formData.emailConfigId ?? 0,

          otherDetail1: formData.otherDetail1 ?? '',
          otherDetail2: formData.otherDetail2 ?? '',
          otherDetail3: formData.otherDetail3 ?? '',
          otherDetail4: formData.otherDetail4 ?? '',
          otherDetail5: formData.otherDetail5 ?? '',
          otherDetail6: formData.otherDetail6 ?? '',

          isActive: 1,
          actionUser: String(this.User.userId),
          DBConnId: formData.DBConfig ?? 0
        }
        this.updateEmailTemplate(data);

      } else {
        const data: CompEmailTempCreateRequestDTO = {
          tenantId: this.companyId,
          tenantBranchId: this.User.loggedInBranchId,

          tName: formData.tName ?? '',
          tDesc: formData.tDesc ?? '',
          moduleName: formData.moduleName ?? '',
          subModuleName: formData.subModuleName ?? '',

          dataSourceType: formData.dataSourceType ?? '',
          dataSourceDefination: formData.dataSourceDefination ?? '',
          postDataSourceType: formData.postDataSourceType ?? '',
          postDataSourceDefination: formData.postDataSourceDefination ?? '',

          emailTO: formData.emailTO ?? '',
          ccTo: formData.ccTo ?? '',
          bccTo: formData.bccTo ?? '',
          aSubject: formData.aSubject ?? '',
          aBody: formData.aBody ?? '',
          emailConfigId: formData.emailConfigId ?? 0,

          otherDetail1: formData.otherDetail1 ?? '',
          otherDetail2: formData.otherDetail2 ?? '',
          otherDetail3: formData.otherDetail3 ?? '',
          otherDetail4: formData.otherDetail4 ?? '',
          otherDetail5: formData.otherDetail5 ?? '',
          otherDetail6: formData.otherDetail6 ?? '',

          actionUser: String(this.User.userId),
          DBConnId: formData.DBConfig ?? 0
        }

        this.createEmailTemplate(data);
      }
    }
  }

  handleActionClick(event: { actionName: string; rowData: CompEmailItem; }) {
    const rowData = { ...event.rowData }
    if (event.actionName === 'View') {
      this.selectedTemplate = rowData;
      this.viewModal = this.modalService.open(this.viewEmailContent, { size: 'xl', scrollable: true });
    }
    else if (event.actionName === "Edit") {
      this.currentStep = 1;
      this.EmailForm.patchValue({ ...rowData });
      if (this.emailDBList.length === 1) this.EmailForm.controls.DBConfig.setValue(this.emailDBList[0].dbConnId);
      if (this.emailConfigList.length === 1) this.EmailForm.controls.emailConfigId.setValue(this.emailConfigList[0].emailConfigId);
      this.templateId = rowData.templateId;
      this.getEmailTemplateVariablesLists(this.templateId)
      this.emailStepperModal = this.modalService.open(this.stepperModalContent, { size: "xl" });

    }
    else if (event.actionName === 'Delete') {
      this.confirmModal.openDeleteModal(rowData.tName!, rowData).subscribe(res => {
        if (res) {
          const tenantId = rowData.tenantId > 0
            ? rowData.tenantId
            : this.companyId;
          const tenantBranchId = rowData.tenantBranchId > 0
            ? rowData.tenantBranchId
            : (this.branchIdControl.value ?? this.User.loggedInBranchId);

          let data: CompEmailTempDeleteRequestDTO = {
            templateId: rowData.templateId,
            tenantId,
            tenantBranchId,
            actionUser: String(this.User.userId)
          }
          this.deleteEmailTemplate(data)
        }
      })
    }



  }

  handleActionClick2(event: { actionName: string; rowData: compEmailVarResponseItem; }) {
    const rowData = { ...event.rowData }
    if (event.actionName === 'Edit Email Variables') {
      this.EmailVariableForm.patchValue({
        variableId: rowData.variableId,
        templateId: rowData.templateId,
        varInstance: rowData.varInstance,
        varValue: rowData.varValue,
        varType: rowData.varType,
        otherDetail1: rowData.otherDetail1,
        otherDetail2: rowData.otherDetail2,
        otherDetail3: rowData.otherDetail3,
        otherDetail4: rowData.otherDetail4,
        otherDetail5: rowData.otherDetail5,
        otherDetail6: rowData.otherDetail6,
      })
    }
    else if (event.actionName === 'Delete') {
      this.confirmModal.openDeleteModal(rowData.varInstance!, rowData).subscribe(res => {
        if (res) {
          const tenantId = rowData.tenantId > 0
            ? rowData.tenantId
            : this.companyId;
          const tenantBranchId = rowData.tenantBranchId > 0
            ? rowData.tenantBranchId
            : (this.branchIdControl.value ?? this.User.loggedInBranchId);

          let data: compEmailTempVarDeleteRequestDTO = {
            variableId: rowData.variableId,
            tenantId,
            tenantBranchId,
            actionUser: String(this.User.userId)
          }
          this.deleteEmailTemplateVariables(data)
        }
      })
    }

  }

  submitEmailForm2() {
    this.EmailVariableForm.markAllAsTouched();

    if (this.EmailVariableForm.invalid) {
      console.warn('Form is invalid. Please correct the errors before submitting.');
      return;
    }
    else {
      const formData = { ...this.EmailVariableForm.value }
      if (formData.variableId && formData.variableId > 0) {
        const data: compEmailTempVarUpdateRequestDTO = {
          variableId: formData.variableId ?? 1,
          templateId: formData.templateId ?? 1,
          tenantId: this.companyId,
          tenantBranchId: this.branchIdControl.value ?? this.User.loggedInBranchId,
          varInstance: formData.varInstance ?? "",
          varValue: formData.varValue ?? "",
          varType: formData.varType ?? "",
          otherDetail1: formData.otherDetail1 ?? "",
          otherDetail2: formData.otherDetail2 ?? "",
          otherDetail3: formData.otherDetail3 ?? "",
          otherDetail4: formData.otherDetail4 ?? "",
          otherDetail5: formData.otherDetail5 ?? "",
          otherDetail6: formData.otherDetail6 ?? "",
          isActive: 1,
          actionUser: String(this.User.userId)
        }
        this.updateEmailTemplateVariables(data);

      } else {
        const data: compEmailTempVarCreateRequestDTO = {
          templateId: this.templateId,
          tenantId: this.companyId,
          tenantBranchId: this.branchIdControl.value ?? this.User.loggedInBranchId,
          varInstance: formData.varInstance ?? "",
          varValue: formData.varValue ?? "",
          varType: formData.varType ?? "",
          otherDetail1: formData.otherDetail1 ?? "",
          otherDetail2: formData.otherDetail2 ?? "",
          otherDetail3: formData.otherDetail3 ?? "",
          otherDetail4: formData.otherDetail4 ?? "",
          otherDetail5: formData.otherDetail5 ?? "",
          otherDetail6: formData.otherDetail6 ?? "",
          actionUser: String(this.User.userId)
        }

        this.createEmailTemplateVariables(data)
      }
    }
  }




  // Branch Id logic 
  getBranchList() {
    const req: BranchMasterReadByUserIdRequestDTO = {
      tenantId: this.companyId,
      actionUser: this.User.userId.toString()
    };
    // BranchMaster is read from the viewed tenant's own server (apiConfigOverride.am)
    // with the admin's own headers, since the viewed tenant may have no
    // CompanyConfig yet. Falls back to the default URL when unassigned.
    this.branchMasterService.BranchMaster_GetDictionary(req, this.apiConfigOverride?.am).subscribe({
      next: (res) => {
        this.branchList = res.dropDownList || [];
        this.branchIdControl.setValue(this.branchList.length > 0 ? +this.branchList[0].key : 0);
        // The first list call fires from ngOnChanges before the branches arrive; without a
        // defaultBranchId from the parent it asks for branch 0, so reload for the branch now selected.
        if (!this.defaultBranchId && this.branchIdControl.value) {
          this.getEmailListPaginated();
        }
      },
      error: (err) => {
        console.error('Error fetching branch list:', err);
        this.branchList = [];
        this.branchIdControl.setValue(0);
      }
    });
  }

  Branchsubmit() {
    let selectedBranchId = this.branchIdControl.value;
    // let selectedBranch = this.branchList.find(branch => +branch.key === selectedBranchId);
    if (selectedBranchId === 0) {
      selectedBranchId = 1;
      this.branchIdControl.setValue(1); // Optional: update the control value too
    }
    this.ReadAllDTO.tenantBranchId = this.branchIdControl.value ?? 1;
    this.getEmailListPaginated();

  }




  // DropDownList Logic 
  getEmailConfigList() {
    const requestData: EmailConfigReadAllRequestDTO = {
      tenantId: this.companyId,
      tenantBranchId: this.defaultBranchId,
      softwareId: 1
    };

    this.emailConfigService.EmailConfig_readAll(requestData, this.apiConfigOverride?.nt, this.companyId, this.defaultBranchId).subscribe({
      next: (response) => {
        this.emailConfigList = response.items;
      },
      error: (error) => {
        console.error('Failed to fetch email config list:', error);
      }
    });
  }

  getDBConfigList() {
    let data: DBConfigReadAllRequestDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: 1
    }

    this.DBConfigService.DBConfig_readAll(data).subscribe({
      next: (response) => {
        this.emailDBList = response.items;
      },
      error: (error) => {
        console.error('Failed to fetch email config list:', error);
      }
    });
  }

  getModuleList() {
    this.SMService.SoftwareMaster_GetDictionary({}).subscribe({
      next: (response) => {
        this.moduleList = response.dropDownList;
      },
      error: (error) => {
        console.error('Failed to fetch email config list:', error);
      }
    });
  }


  getEmailTemplateVariablesLists(tempId: number) {
    const data: compEmailTempVarReadByTemplateIdRequestDTO = {
      templateId: tempId,
      tenantId: this.companyId,
      tenantBranchId: this.branchIdControl.value ?? this.defaultBranchId
    }
    this.emailVaribleService.CompanyEmailTemplateVariable_ReadByTemplateId(data, this.apiConfigOverride?.am, this.companyId, data.tenantBranchId).subscribe({
      next: (response) => {
        this.emailVariableList = response.items;

      },
      error: (error) => {
        console.error("Failed to fetch EMail Varibale Data", error)
      }
    });
  }

  createEmailTemplateVariables(data: compEmailTempVarCreateRequestDTO) {
    this.emailVaribleService.CompanyEmailTemplateVariable_Create(data).subscribe({
      next: () => {
        this.EmailVariableForm.reset()
        this.getEmailTemplateVariablesLists(this.templateId)
      },
      error: (err) => {
        console.error('Create error:', err);
      }
    });
  }

  updateEmailTemplateVariables(data: compEmailTempVarUpdateRequestDTO) {
    this.emailVaribleService.CompanyEmailTemplateVariable_Update(data).subscribe({
      next: () => {
        // close all modam if it opens 
        this.EmailVariableForm.reset()
        this.getEmailTemplateVariablesLists(this.templateId)
      },
      error: (err) => {
        console.error('Update error:', err);
      }
    })
  }

  deleteEmailTemplateVariables(data: compEmailTempVarDeleteRequestDTO) {
    this.emailVaribleService.CompanyEmailTemplateVariable_Delete(data).subscribe(res => {
      this.EmailVariableForm.reset()
      this.getEmailTemplateVariablesLists(this.templateId)
    })
  }

  handlePageSizeChange(event: { currentPage: number; pageSize: number; }) {

    const { currentPage, pageSize } = event
    this.ReadAllDTO.pageNo = currentPage
    this.ReadAllDTO.pageSize = pageSize

    this.getEmailListPaginated()

  }


  currentStep = 1;
  nextStep() {
    if (this.currentStep === 1 && this.EmailForm.get('tName')?.invalid) {
      this.EmailForm.get('tName')?.markAsTouched();
      return;
    }
    if (this.currentStep < 3) {
      this.currentStep++;
    }
  }
  previousStep() {
    if (this.currentStep > 1) this.currentStep--;
  }
  generate() {
    this.loadingAITemplate = true;

    let queryString: string = this.EmailForm.controls.aBody.value ?? ''

    this.openAIService.GenerateEmailTemplate(queryString).subscribe(res => {
      this.EmailForm.controls.aBody.patchValue(res)
      this.loadingAITemplate = false;

    })
  }


  addSendModel!: NgbModalRef;
  @ViewChild('SendEmailForm', { static: false }) SendEmailForm!: ElementRef;

  handleInlineButtonClick = (rowData: any) => {
    // rowData.isLoading = true;
    this.addSendModel = this.modalService.open(this.SendEmailForm, { size: "xl" });
    const formData = { ...this.EmailForm.value }

    this.EmailForm.patchValue({
      templateId: rowData.templateId,
      tName: rowData.tName,
      tDesc: rowData.tDesc,
      moduleName: rowData.moduleName,
      subModuleName: rowData.subModuleName,
      dataSourceType: rowData.dataSourceType,
      dataSourceDefination: rowData.dataSourceDefination,
      postDataSourceType: rowData.postDataSourceType,
      postDataSourceDefination: rowData.postDataSourceDefination,
      emailTO: rowData.emailTO,
      ccTo: rowData.ccTo,
      bccTo: rowData.bccTo,
      aSubject: rowData.aSubject,
      aBody: rowData.aBody,
      emailConfigId: rowData.emailConfigId,
      DBConfig: rowData.DBConnId,
      otherDetail1: rowData.otherDetail1,
      otherDetail2: rowData.otherDetail2,
      otherDetail3: rowData.otherDetail3,
      otherDetail4: rowData.otherDetail4,
      otherDetail5: rowData.otherDetail5,
      otherDetail6: rowData.otherDetail6,
      whereClause: formData.whereClause
    })

  }


  onSubmitAction() {
    this.EmailForm.markAllAsTouched();
    this.sendEmailLoader = true

    if (this.EmailForm.invalid) {
      console.warn('Form is invalid. Please correct the errors before submitting.');
      this.sendEmailLoader = false
      return;
    }
    // Prepare data for NotificationMaster_Create
    const data: NotificationMaster_CreateRequestDTO = {
      alertConfigId: Number(this.EmailForm.value.emailConfigId),
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: 1,
      nType: 'Email',
      nSubject: this.EmailForm.value.aSubject ?? "",
      nContent: this.EmailForm.value.aBody ?? "",
      nTo: this.EmailForm.value.emailTO ?? " ",
      nCc: this.EmailForm.value.ccTo ?? " ",
      nBcc: this.EmailForm.value.bccTo ?? " ",
      nStatus: 'Pending',
      remarks: '',
      scheduledDate: new Date().toISOString(),
      attachmentPath: '',
      retryCount: 0,
      retryDate: null,
      postSendDataSourceType: this.EmailForm.value.postDataSourceType ?? "",
      postSendDataSourceDef: this.EmailForm.value.postDataSourceDefination ?? "",
      dbConnId: this.EmailForm.value.DBConfig ?? 0,
      actionUser: this.User.userId.toString()
    };

    this.historyService.notificationMaster_Create(data).subscribe({
      next: () => {
        this.addSendModel.close()
        this.sendEmailLoader = false
      },
      error: (err) => {
        console.log('Error sending Email Notification:', err)
        this.sendEmailLoader = false
      }
    });
  }


}
